import { render, staticRenderFns } from "./vizlet_settings.vue?vue&type=template&id=624678ea"
import script from "./vizlet_settings.vue?vue&type=script&lang=js"
export * from "./vizlet_settings.vue?vue&type=script&lang=js"
import style0 from "./vizlet_settings.vue?vue&type=style&index=0&id=624678ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports